if (!customElements.get('ac-facet-options')) {
  customElements.define('ac-facet-options', class extends HTMLElement {
    connectedCallback() {
      const url = new URL(window.location.href);
      const retiredFilters = ['filter.p.m.custom.sales-type', 'filter.v.price.gte', 'filter.v.price.lte'];
      let changed = false;
      retiredFilters.forEach((name) => {
        if (url.searchParams.has(name)) changed = true;
        url.searchParams.delete(name);
      });
      if (!changed) return;
      url.searchParams.delete('page');
      const theme = window.Shopify?.theme;
      if (theme?.id && theme.role !== 'main') url.searchParams.set('preview_theme_id', theme.id);
      window.location.replace(url.toString());
    }
  });
}
